import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Error404 = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-800 dark:text-gray-200 mb-4">
          404
        </h1>
        <h2 className="text-2xl font-semibold mb-4">
          {t("pageNotFound", "Page Not Found")}
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          {t("pageNotFoundDesc", "The page you're looking for doesn't exist.")}
        </p>
        <Link
          to="/"
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded transition-colors"
        >
          {t("goHome", "Go Home")}
        </Link>
      </div>
    </div>
  );
};

export default Error404;
